import i18next from 'i18next';

i18next.addResources('es_CL', 'NewOrder', {
  title: 'Pedido Nuevo',
  orderSummary: 'Resumen pedido:',
  client: 'Cliente',
  delivery: 'Delivery Mercat',
  inStore: 'Retiro en local',
  baralonso: 'Mercat',
  justburger: 'Just Burger',
  storeDelivery: 'Delivery',
  deferred: 'Pedido diferido - Plazo de preparación:',
  deliveryDate: 'Fecha de entrega:'
});

i18next.addResources('es_CR', 'NewOrder', {
  title: 'Pedido Nuevo',
  orderSummary: 'Resumen pedido:',
  client: 'Cliente',
  delivery: 'Delivery Mercat',
  inStore: 'Retiro en local',
  baralonso: 'Mercat',
  justburger: 'Just Burger',
  storeDelivery: 'Delivery',
  deferred: 'Pedido diferido - Plazo de preparación:',
  deliveryDate: 'Fecha de entrega:'
});
